function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 312.882h512v113.775H0zm322.783-86.569v-22.261h7.42v-14.84h-14.841v7.419h-14.84v-7.419h-14.84v14.84h7.419v22.261h-14.84v-51.94h7.421v-14.842H270.84v7.42h-7.419v-7.42h-14.842v7.42h-7.419v-7.42h-14.842v14.842h7.421v51.94h-14.84v-22.261h7.419v-14.84h-14.84v7.419h-14.84v-7.419h-14.841v14.84h7.42v22.261h-14.84v59.362h163.246v-59.362z",
  fill: "#d80027"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M256 278.255c-12.295 0-22.261 9.966-22.261 22.261 0 9.691 6.195 17.933 14.84 20.989v30.953h-22.261v29.682h37.101v-60.634c8.646-3.055 14.841-11.297 14.841-20.989.001-12.296-9.965-22.262-22.26-22.262zm0 29.681a7.421 7.421 0 110-14.842 7.421 7.421 0 010 14.842z",
  fill: "#ffda44"
});

const SvgGibraltar = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGibraltar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gibraltar.87cabd4e.svg";
export { ForwardRef as ReactComponent };